import moment from 'moment-timezone';
import uuidTime from 'uuid-time';
import { timeFormats } from 'constants/constants';

export const getUUIDDate = (encodedId) => moment(uuidTime.v1(encodedId)).format(timeFormats.DATE_MONTH);
export const getUUIDDateTime = (encodedId) => moment(uuidTime.v1(encodedId)).format(timeFormats.DATE_MONTH_TIME);